import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class LoanappService {
  authToken: any;
  user: any;
  baseURI: any;

  constructor(private http: HttpClient, private auth: AuthService) {
    this.baseURI = this.auth.baseURL;
  }

  getLoanApp(params = {}) {
    return this.http.get(this.baseURI + 'lapp/getLoanApp', {
      params,
    });
  }

  getLoanApplicationReportbyMonth(obj = {}) {
    return this.http.get(
      this.baseURI + `reports/loan/application/loan-application`,
      { params: obj }
    );
  }

  getLoanApplicationReporOnlyApproved(obj = {}) {
    return this.http.get(
      this.baseURI + `reports/loan/application/loan-application/approved`,
      { params: obj }
    );
  }

  getLoanApplicationReporOnlyApprovedMisColl(obj = {}) {
    return this.http.get(
      this.baseURI + `reports/loan/application/loan-mis`,
      { params: obj }
    );
  }

  // Outstanding Loans
  getOutstandingLoans(obj = {}) {
    return this.http.get(
      this.baseURI + `reports/loan/application/outstanding`,
      { params: obj }
    );
  }

  getLoanApplicationByStatusAndState(obj) {
    return this.http.post(this.baseURI + `lapp/loan-application-states/`, obj);
  }

  getCmaAppointedApplications() {
    return this.http.get(this.baseURI + 'lapp/getCmaAppointedApplications');
  }

  getLoanAppforCMAWithStatus(obj) {
    return this.http.post(
      this.baseURI + `reports/cma/loan-application-cma-tat/`,
      obj
    );
  }

  getAllLoansApplied(params = {}) {
    return this.http.get(this.baseURI + 'lapp/getAllLoansApplied', {
      params,
    });
  }

  getLoanAppOnlyApproved(params = {}) {
    return this.http.get(this.baseURI + 'lapp/getLoanAppOnlyApproved', {
      params,
    });
  }

  getLoanAppOnlyDisbursed(params = {}) {
    return this.http.get(this.baseURI + 'lapp/getLoanAppOnlyDisbursed', {
      params,
    });
  }

  disburseLoan(id, payload = {}) {
    return this.http.patch(this.baseURI + 'lapp/disburseLoan/' + id, payload);
  }

  getLoanAppDetails(id, uId) {
    return this.http.get(this.baseURI + `lapp/getLoanAppDetails/${id}/${uId}`);
  }

  recentAct(uId, params = {}) {
    return this.http.get(this.baseURI + `lapp/recentAct/${uId}`, {
      params,
    });
  }

  getLoanAppDetailsCMA(id) {
    return this.http.get(this.baseURI + `lapp/getLoanAppDetailsCMA/${id}`);
  }

  getAllCma() {
    return this.http.get(this.baseURI + `lapp/getAllCma`);
  }

  changeStatus(obj) {
    return this.http.post(this.baseURI + `lapp/changeStatusLA`, obj);
  }

  sendNotification(obj) {
    return this.http.post(this.baseURI + `lapp/sendNotification`, obj);
  }

  approveLoanApplication(obj) {
    return this.http.post(this.baseURI + `lapp/approveLoanApplication`, obj);
  }

  checkedByMaker(obj) {
    return this.http.post(this.baseURI + `lapp/checkedByMaker`, obj);
  }

  getLAppDetailsForReceipt(whrId, uId) {
    return this.http.get(
      this.baseURI + `lapp/getLAppDetailsForReceipt/${whrId}/${uId}`
    );
  }

  sendTestAgreementEmail(obj) {
    return this.http.post(this.baseURI + `lapp/sendAgreementEmail`, obj);
  }
  userAcceptLoanAgreement(obj) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseURI + `lapp/userAcceptLoanAgreement`, obj);
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }

  getBorrowerWiseData(obj) {
    return this.http.post(
      this.baseURI + `reports/loan/loan-application-by-borrowers`,
      obj
    );
  }

  getCMAReport(obj) {
    return this.http.post(this.baseURI + `reports/cma/tat`, obj);
  }

  getApprovedLoanReport(obj) {
    return this.http.post(
      this.baseURI + `reports/loan/loan-application-by-warehouse-location`,
      obj
    );
  }

  getBorrwerReport(params = {}) {
    return this.http.get(this.baseURI + 'reports/loan/borrowers/top-10', {
      params,
    });
  }

  otpForVer(id) {
    return this.http.get(this.baseURI + `lapp/u_pNo_a/${id}`);
  }

  verifyOTP(obj) {
    return this.http.post(this.baseURI + 'lapp/verifyOtp', obj);
  }

  sanctionConsentD(appId) {
    return this.http.get(this.baseURI + `lapp/sanctionConsentD/${appId}`);
  }

  filterByDateSanctioned(sDate, eDate) {
    return this.http.get(
      this.baseURI + `lapp/filterByDateSanctioned/${sDate}/${eDate}`
    );
  }

  filterByDatePendingApp(sDate, eDate) {
    return this.http.get(
      this.baseURI + `lapp/filterByDatePendingApp/${sDate}/${eDate}`
    );
  }

  filterByTimestamp(sDate, eDate) {
    return this.http.get(
      this.baseURI + `lapp/filterByTimestamp/${sDate}/${eDate}`
    );
  }

  getCommodityPrice(depositId) {
    return this.http.get(this.baseURI + `commodity/market-rates/${depositId}`);
  }
  lendingPartners() {
    return this.http.get(this.baseURI + `lapp/lendingPartners`);
  }
  saveLendingPartner(obj) {
    return this.http.post(this.baseURI + `lapp/saveLendingPartner`, obj);
  }
}
